// extracted by mini-css-extract-plugin
export var carrierTab = "_5o-0";
export var carrierTabActive = "_5o-1 _5o-0";
export var carrierTabInactive = "_5o-2 _5o-0";
export var carrierTabLabel = "_5o-3";
export var carrierTabLabelActive = "_5o-4 _5o-3";
export var carrierTabLabelInactive = "_5o-5 _5o-3";
export var carrierTabPercentage = "_5o-6";
export var carrierTabPercentageActive = "_5o-7 _5o-6";
export var carrierTabPercentageInactive = "_5o-8 _5o-6";
export var carrierTabWinnable = "_5o-9";
export var carrierTabWinnableActive = "_5o-a _5o-9";
export var carrierTabWinnableInactive = "_5o-b _5o-9";
export var comparisonContainer = "_5o-d";
export var missingRateButton = "_5o-n";
export var missingRateButtonActive = "_5o-o _5o-n";
export var missingRateButtonInactive = "_5o-p _5o-n";
export var missingRateButtonLabel = "_5o-q";
export var missingRateButtonLabelActive = "_5o-r _5o-q";
export var missingRateButtonLabelInactive = "_5o-s _5o-q";
export var sidebar = "_5o-c";
export var strategyButton = "_5o-e";
export var strategyButtonActive = "_5o-f _5o-e";
export var strategyButtonDescription = "_5o-k";
export var strategyButtonDescriptionActive = "_5o-l _5o-k";
export var strategyButtonDescriptionInactive = "_5o-m _5o-k";
export var strategyButtonInactive = "_5o-g _5o-e";
export var strategyButtonLabel = "_5o-h";
export var strategyButtonLabelActive = "_5o-i _5o-h";
export var strategyButtonLabelInactive = "_5o-j _5o-h";
export var unitToggleButton = "_5o-t";
export var unitToggleButtonActive = "_5o-u _5o-t";
export var unitToggleButtonInactive = "_5o-v _5o-t";
export var unitToggleButtonLabel = "_5o-w";
export var unitToggleButtonLabelActive = "_5o-x _5o-w";
export var unitToggleButtonLabelInactive = "_5o-y _5o-w";